var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapsedArrowsRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0L15 8L7 16H11L18.29 8.71C18.3837 8.61704 18.4581 8.50644 18.5089 8.38458C18.5597 8.26272 18.5858 8.13201 18.5858 8C18.5858 7.86799 18.5597 7.73728 18.5089 7.61542C18.4581 7.49356 18.3837 7.38296 18.29 7.29L11 0H7Z",
    fill: "#FFAF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 0L8 8L0 16H4L11.29 8.71C11.3837 8.61704 11.4581 8.50644 11.5089 8.38458C11.5597 8.26272 11.5858 8.13201 11.5858 8C11.5858 7.86799 11.5597 7.73728 11.5089 7.61542C11.4581 7.49356 11.3837 7.38296 11.29 7.29L4 0H0Z",
    fill: "#FFAF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapsedArrowsRight);
export default __webpack_public_path__ + "static/media/collapsed-arrows-right.381e8913adf769ee177cb70da7cccb86.svg";
export { ForwardRef as ReactComponent };